import React from 'react'
import PubSub from 'services/PubSub';
import { actionsType } from 'config/constants';
import SubscribeForm from './SubscribeForm'
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss'

const Subscribe = () => {
    const isMobile = useViewportMediaQuery(1024)
    
    const openNewsletter = () => {
        PubSub.dispatch(actionsType.MODAL.NEWSLETTER_OPEN);
    }

    return (
        <div className="subscribe">
            {isMobile ? (
                <div className="subscribe-wrapper-mobile">
                    <span className="subscribe-title">Conoce nuestras ofertas y novedades</span>
                    <div className="subscribe-button">
                        <button className="primary-btn" onClick={openNewsletter}>Suscríbete</button>
                    </div>
                </div>
            ) : (
                <div className="subscribe-wrapper-desktop">
                    <span className="subscribe-title">Suscríbete a nuestras ofertas y novedades</span>
                    <SubscribeForm />
                </div>
            )}
        </div>
    )
    
}

export default Subscribe